var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Companies Directory',"subtitle":'Add new company'}}),_c('company-form',{attrs:{"action":'add'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }